function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

var fbCircle = {
  "id": "fbCircle",
  "symbol": "<symbol id=\"fbCircle\" viewBox=\"0 0 32 32\" ><path d=\"M5.84307 0C2.6063 0 6.10352e-05 2.60624 6.10352e-05 5.84301V26.157C6.10352e-05 29.3938 2.6063 32 5.84307 32H16.8531V19.49H13.5451V14.986H16.8531V11.138C16.8531 8.11482 18.8076 5.33901 23.3101 5.33901C25.1331 5.33901 26.4811 5.51402 26.4811 5.51402L26.3751 9.72003C26.3751 9.72003 25.0003 9.70704 23.5001 9.70704C21.8764 9.70704 21.6161 10.4551 21.6161 11.6971V14.986H26.5041L26.2911 19.49H21.6161V32.0001H26.1571C29.3938 32.0001 32.0001 29.3938 32.0001 26.1571V5.84304C32.0001 2.60627 29.3938 3.2e-05 26.1571 3.2e-05H5.84304L5.84307 0Z\" fill=\"#6B7F99\"/></symbol>"
};

export { fbCircle };
